var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("\n      404\n      "),_c('em',[_vm._v(_vm._s(_vm.$vuetify.lang.translator("not_found")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }